
    import React from 'react';
    import ReactDOM from 'react-dom';
    import Component from '/home/circleci/app/packages/layout-identification-component/src/entries/IdentificationMarketplaceModal';

    const element = typeof document !== 'undefined' && document.querySelector('#LayoutIdentificationComponent-IdentificationMarketplaceModal-component');

    if (element) {
        const props = window.initialData['LayoutIdentificationComponent-IdentificationMarketplaceModal'];

        ReactDOM.render(
            <Component {...props}/>,
            element
        );
    }

    export default Component;
    